import {appendAndFocusSearchBar} from '@github-ui/append-and-focus-search-bar'
import {DuplicateOnKeydownButton} from '@github-ui/code-view-shared/components/DuplicateOnKeydownButton'
import {useShortcut} from '@github-ui/code-view-shared/hooks/shortcuts'
import {SearchIcon} from '@primer/octicons-react'
import type {BetterSystemStyleObject} from '@primer/styled-react'
import {IconButton} from '@primer/styled-react'
import type React from 'react'

import styles from './SearchButton.module.css'

export default function SearchButton({
  sx,
  onClick,
  textAreaId,
}: {
  sx?: BetterSystemStyleObject
  onClick?: () => void
  textAreaId: string
}) {
  const {searchShortcut} = useShortcut()
  return (
    <>
      <IconButton
        aria-label="Search this repository"
        tooltipDirection="nw"
        icon={SearchIcon}
        data-hotkey={searchShortcut.hotkey}
        sx={sx}
        size="medium"
        onClick={(e: React.MouseEvent) => {
          onClick?.()
          appendAndFocusSearchBar({
            retainScrollPosition: true,
            returnTarget: (e.target as HTMLElement).closest('button') as HTMLElement,
          })
        }}
        className={styles.IconButton}
      />
      <DuplicateOnKeydownButton
        buttonFocusId={textAreaId}
        buttonHotkey={searchShortcut.hotkey}
        onButtonClick={() => {
          const textArea = document.getElementById(textAreaId)
          onClick?.()
          appendAndFocusSearchBar({
            retainScrollPosition: true,
            returnTarget: textArea ?? undefined,
          })
        }}
        onlyAddHotkeyScopeButton
      />
    </>
  )
}
